<template>
  <div>
    <!--顶部按钮-->
    <div class="app-container">
      <div style="height: 30px">
        <vxe-button v-auth="`ADD`" @click="goAdd"> <a-icon type="diff"/> 新增</vxe-button>
        <vxe-button v-auth="`IMPORT`" @click="uploadFun">导入</vxe-button>
        <vxe-button v-auth="`EXPORT`" @click="deriveFun">导出</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <div v-if="!showdiv">
            <a-input v-model="queryCondition.materialCode" placeholder="物料号" clearable style="width: 150px; margin-right: 1rem" @keyup.enter.native="queryByPage()" />
            <a-input v-model="queryCondition.materialName" placeholder="物料名称" clearable style="width: 150px; margin-right: 1rem" @keyup.enter.native="queryByPage()" />
          </div>
          <div>
            <vxe-button v-if="!showdiv" status="primary" @click="queryByPage(1)">搜索</vxe-button>
            <vxe-button v-if="!showdiv"  class="filter-search-item" @click="resetForm">重置</vxe-button>
            <vxe-button type="warning"  @click="cb">
              {{ showdiv ? '收起' : '更多选项' }}
            </vxe-button>
          </div>
        </div>
      </div>
      <!--筛选拓展-->
      <div style="margin-top: 10px">
        <a-collapse>
          <div v-if="showdiv">
            <div v-if="showdiv">
              <SiftMaterial :data.sync="queryCondition" :type="siftType" :list="SelectLists" />
              <br>
              <div slot="footer" style="text-align: center; padding-bottom: 10px">
                <vxe-button @click="resetForm">重置</vxe-button>
                <vxe-button status="primary" @click="queryByPage(1)">搜索</vxe-button>
              </div>
            </div>
          </div>
        </a-collapse>
      </div>
      <!--table列表-->
      <vxe-table
        ref="xTable"
        v-loading="listLoading"
        :align="allAlign"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        border
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="tableData"
        @sort-change="listSortMethod"
      >
        <vxe-column type="checkbox" width="40" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column field="materialCode" title="物料号" width="150" />
        <vxe-column field="materialName" title="物料名称" width="300" />
        <vxe-column field="materialType" title="物料类型" width="100">
          <template #default="{ row }">
            <!--  <span v-if="row.materialType === '1'">销售物料</span>
            <span v-else-if="row.materialType === '2'">礼品物料</span>
            <span v-else-if="row.materialType === '3'">宣传物料</span>
            <span v-else>其它</span> -->
            {{ row.materialType }}
          </template>
        </vxe-column>
        <!-- <vxe-column field="specification" title="物料规格" width="100" /> -->
        <!-- <vxe-column field="storage" title="库存" width="100" /> -->
        <vxe-column field="storage" title="库存量" width="100" sortable/>
        <!-- lr001 -->
        <vxe-column field="price" title="申领价（元）" width="100"  sortable>
          <template #default="{ row }">
            {{ row.price | toThousandNumFilter }}
          </template>
        </vxe-column>
        <vxe-column field="prodPrice" title="制作价（元）" width="100"  sortable>
          <template #default="{ row }">
            {{ row.prodPrice | toThousandNumFilter }}
          </template>
        </vxe-column>
        <vxe-column field="unit" title="单位" width="100" />
        <!-- lr003 -->
        <!-- <vxe-column field="warehouse" title="所属仓库" width="150">
          <template #default="{ row }">
            <span v-if="row.warehouse === '1'">外部仓库</span>
            <span v-else-if="row.warehouse === '2'">内部仓库</span>
          </template>
        </vxe-column> -->
        <!-- lr006 -->
        <!-- <vxe-column field="supplier" title="供应商" width="150" /> -->
        <vxe-column field="remark" title="备注" width="150" />
        <!-- <vxe-column field="createUser" title="新增人" width="100" />
        <vxe-column field="createrDate" title="新增时间" width="150" sortable />
        <vxe-column field="updateTime" title="更新时间" width="150" sortable /> -->
        <!-- <vxe-column field="fileId" title="物料图片" width="150" /> -->
        <vxe-column title="操作" width="400" fixed="right" align="center">
          <template #default="{ row }">
            <div class="operate">
              <a-button size="small" type="link" v-auth="`UPDATE`" @click="editFun(row)">修改</a-button>
              <a-button size="small" type="link" v-auth="`INWAREHOUSE`" @click="addInFun(row)">增加入库</a-button>
              <a-button size="small" type="link" v-if="row.storage > 0" v-auth="`OUTWAREHOUSE`" @click="addOutFun(row)">减少入库</a-button>
              <a-button size="small" type="link" v-auth="`APPLY`" @click="cancelApply(row)">
                <span v-if="row.isApply === '1'">取消申领</span>
                <span v-if="row.isApply === '0'">开通申领</span>
              </a-button>
              <a-button size="small" type="link" v-auth="`VIEW`" @click="picInfo(row)">详细信息</a-button>
              <a-button size="small" type="link" v-auth="`DELETE`" @click="deleteFun(row)" :disabled="row.isApply === '1'" :title="row.isApply === '1' ? '物料已经被申领，不能删除': '' ">删除</a-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />
    </div>
    <!--导入对话框 -->
    <a-modal title="导入Excel" v-model="uploadDialog" width="400px" :footer="null" @cancel="onUploadCancel">
      <div :loading="importLoading" class="faultAdd">
        <div class="model-box">
          <a class="load-buttom" href="/file/广宣物料导入模板.xlsx" download><i class="el-icon-download" />下载示例模板</a>
        </div>
        
        <el-upload ref="upload" class="upload-demo" drag action="" multiple :http-request="upload" :before-upload="uploadBefore" :file-list="fileList">
          <i class="el-icon-upload" />
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">直接导入已填好的Excel列表，仅支持XLS/XLSX</div>
        </el-upload>
        <div v-if="errorList.length>0" class="err-box">
          <a-button type="link" danger>Excel导入出错，请检查错误行，然后将错误行重新导入</a-button>
          <div v-for="item in errorList" :key="item.row">
            <a-button type="link">第{{ item.row }}行{{ item.error }}</a-button>
          </div>
        </div>
      </div>
    </a-modal>
    <!--导出对话框 -->
    <a-modal title="选择导出项" v-model="dialogVisible" width="400px">
      <a-radio-group v-model="ExportItem">
        <a-radio :value="0">导出全部</a-radio>
        <a-radio :value="1">导出当前页</a-radio>
        <a-radio :value="2" :disabled="disabled">导出已选择项</a-radio>
      </a-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button size="small" @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button size="small" status="primary" :loading="outExcelButtonLocading" @click="exportXlsxFun">确 定</vxe-button>
      </span>
    </a-modal>
  </div>
</template>

<script>
import { materialfindList, deleteMaterial, cancelApply, exportMaterial, uploadMaterial } from '@/api/material'
// import { outExcel } from '@/utils/Excel/outExcel'
import SiftMaterial from './components/SiftMaterial.vue'

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

export default {
  // 广宣物料管理/广宣物料维护,
  name: 'PublicizeMaterialMaintenance',
  components: {
    SiftMaterial
  },
  data() {
    return {
      showdiv: false,
      pagination: Object.assign({}, defaultPagination),
      listLoading: false,
      tableData: [],
      allAlign: 'center',
      queryCondition: {},
      // 筛选条件框类型 0物料维护，1入库，2出库
      siftType: 0,
      // 导出对话框
      dialogVisible: false,
      disabled: true, // 已选择按钮是否禁用
      outExcelButtonLocading: false,
      ExportItem: 0,
      fileList: [],
      errorList: [],
      uploadDialog: false,
      importLoading: false,
      SelectLists: {},
      sort: 'creater_date desc'
    }
  },

  watch: {},
  activated() {
    console.log('activated')
    this.queryByPage()
  },
  created() {
    // 获取表格数据
    this.queryByPage()
    // 获取下拉框列表
    this.SelectListFun()
  },
  mounted() {},
  methods: {
    //  新增跳转
    goAdd() {
      this.$router.push({ path: 'addMaterial/null' })
    },
    deriveFun() {
      this.dialogVisible = true
      // 判断是否选中
      this.disabled = this.$refs.xTable.selection.length < 1
    },
    exportAuot(data) {
      exportMaterial(data).then(val => {
        this.$exportExcelData(val, `广宣物料表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
        this.dialogVisible = false
        this.outExcelButtonLocading = false
      })
    },
    // 导出表格
    async exportXlsxFun() {
      // 需要导出的数据
      let data = []
      let ids = []
      // const typeMap = new Map([
      //   ['1', '销售物料'],
      //   ['2', '礼品物料'],
      //   ['3', '宣传物料'],
      //   ['4', '其它']
      // ])
      // const warehouse = new Map([
      //   ['1', '外部仓库'],
      //   ['2', '内部仓库']
      // ])
      this.outExcelButtonLocading = true
      if (this.ExportItem == 0) {
        if (this.pagination.total > 10000) {
          this.$message.warning('导入' + this.pagination.total + '条，过程可能持续数分钟。')
        }
        let params = { page: 1, limit: this.pagination.total, sort: this.sort, ...this.queryCondition }
        this.exportAuot(params)
        return
      } else if (this.ExportItem == 1) {
        data = this.tableData
        ids = data.map((item) => item.materialId);
        let params = { page: 1, limit: this.pagination.total, ids: ids, sort: this.sort, ...this.queryCondition }
        this.exportAuot(params)
      } else if (this.ExportItem == 2) {
        data = this.$refs.xTable.selection
        ids = data.map((item) => item.materialId);
        let params = { page: 1, limit: this.pagination.total, ids: ids, sort: this.sort, ...this.queryCondition }
        this.exportAuot(params)
      }
      // let table = []
      // for (var i = 0; i < data.length; i++) {
      //   var params = {
      //     物料号: data[i].materialCode,
      //     物料名称: data[i].materialName,
      //     // 物料类型: data[i].materialType,
      //     物料类型: typeMap.get(data[i].materialType),
      //     物料规格: data[i].specification,
      //     库存: data[i].storage,
      //     申领价: data[i].price,
      //     制作价: data[i].prodPrice,
      //     单位: data[i].unit,
      //     // 所属仓库: data[i].warehouse,
      //     所属仓库: warehouse.get(data[i].warehouse),
      //     供应商: data[i].supplier,
      //     备注: data[i].remark,
      //     新增人: data[i].createUser,
      //     新增时间: data[i].createrDate,
      //     更新时间: data[i].updateTime
      //   }
      //   table[i] = params
      // }
      // const wch = [15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 25, 25]
      // outExcel('广宣物料表', table, wch)
      // 关闭弹窗
      this.dialogVisible = false
      this.outExcelButtonLocading = false
    },
    // 导入弹窗
    uploadFun() {
      this.uploadDialog = true
    },
    // 上传前对文件的大小的判断
    uploadBefore(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message('只能上传后缀是.xlsx或者.xls的文件')
        return false
      }

      if (size > 10) {
        this.$message('文件大小不得超过10M')
        return false
      }
    },
    // 上传
    upload(file) {
      let formData = new FormData()
      formData.append('file', file.file)
      this.importLoading = true
      uploadMaterial(formData).then(res => {
        this.importLoading = false
        if (res.code === 1) {
          if (res.data == null) {
            this.$message.success('上传成功')
            this.$refs.upload.clearFiles()
            this.uploadDialog = false
            this.errorList = []
          } else {
            this.errorList = res.data
            this.$message.error(res.message)
          }
          this.queryByPage()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 分页
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.queryByPage()
    },
    // 重置筛选
    resetForm() {
      this.queryCondition = {}
      this.queryByPage(1)
    },
    listSortMethod({ sortList }) {
      let sort = ''
      for (let i = 0; i < sortList.length; i++) {
        if (i !== 0) {
          sort = sort + ','
        }
        sort = sort + sortList[i].property + ' ' + sortList[i].order
      }
      this.sort = sort
      this.queryByPage()
    },
    // 获取下拉列表
    SelectListFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['PromotionMaterialType', 'PromotionStockType']).then(v => {
        this.SelectLists = v
      })
    },
    // 查询表格数据
    async queryByPage(e) {
      if (e) this.pagination.current = e
      // 筛选条件
      const queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        ...this.queryCondition,
        sort: this.sort
      }
      this.listLoading = true // 开启加载动画
      materialfindList(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          this.listLoading = false
        } else {
          this.$message.error('查询失败')
        }
      })
    },
    cb() {
      this.showdiv = !this.showdiv
    },
    // 详细信息
    picInfo(row) {
      this.$router.push({ path: `detailMaterial/${row.materialId}` })
    },
    // 删除物料信息
    deleteFun(row) {
      let data = {
        id: row.materialId
      }
      this.$confirm({
        title: '提示',
        content: '确定删除该物料？',
        onOk:() =>{
          deleteMaterial(data).then(res => {
            if (res.code === 1) {
              this.$message.success('删除成功')
              this.queryByPage()
            } else {
              this.$message.error(res.$message)
            }
          })
        },
        onCancel() {},
      });
    },
    // 修改物料信息
    editFun(row) {
      this.$router.push({ path: `editMaterial/${row.materialId}` })
    },
    // 增加入库
    addInFun(row) {
      this.$router.push({ path: `addInWarehouse/${row.materialId}` })
    },
    // 减库操作
    addOutFun(row) {
      this.$router.push({ path: `addOutWarehouse/${row.materialId}` })
    },
    // 取消申领,开通申领
    cancelApply(row) {
      let data = {
        id: row.materialId,
        materialName: row.materialName,
        materialCode: row.materialCode,
        isApply: row.isApply
      }
      let confirmTip

      if (row.isApply === '0') {
        data.isApply = '1'
        confirmTip = '确定开通申领?'
      } else {
        data.isApply = '0'
        confirmTip = '确定取消申领?'
      }
      this.$confirm({
        title: '提示',
        content: confirmTip,
        onOk:() => {
          cancelApply(data).then(res => {
          if (res.code === 1) {
            this.$message.success('修改成功')
            this.queryByPage()
          } else {
            this.$message.error(res.$message)
            }
          })
        },
        onCancel() {},
      });
    },
    onUploadCancel() {
      this.errorList = []
      this.fileList = []
    }
  }
}
</script>
<style lang="less">
.a-input--medium .a-input__inner {
  height: 30px;
}
.operate {
  display: flex;
  justify-content: space-around;
}
.el-link {
  font-size: 12px;
}
.load-buttom {
  text-decoration: none;
  // float: right;
  height: 30px;
  padding: 0 10px;
  text-align: right;
  line-height: 30px;
  color: #00a7e5;
  display: inline-block;
  font-size: 12px;
}
.load-buttom:hover {
  color: #00b7bf;
}
.err-box {
  margin-top: 10px;
}
.pic-box {
  display: inline-block;
  padding: 5px;
}
</style>
